"use client";

import { usePathname } from "next/navigation";

import { ErrorState } from "@/components/states/error-state";

export default function LocaleErrorPage({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const pathname = usePathname();
  const isArabic = pathname.startsWith("/ar");

  return (
    <main className="standalone-shell">
      <ErrorState
        description={
          isArabic
            ? "حدث خلل أثناء فتح هذه الصفحة. حاول مرة أخرى."
            : "Something went wrong while opening this page. Try again."
        }
        label={isArabic ? "خطأ" : "Error"}
        onRetry={reset}
        retryLabel={isArabic ? "إعادة المحاولة" : "Try again"}
        title={isArabic ? "تعذر فتح الصفحة" : "Unable to open this page"}
      />
    </main>
  );
}
